module.exports = __webpack_public_path__ + "img/bg-blog-test.7093c2a4.png";